import React, { useEffect, useState } from 'react'
import {
  Card,
  CardContent,
  Typography,
  Link,
  Box,
  TextField,
  Button,
  InputAdornment,
} from '@material-ui/core'
import { ThumbUpAlt, ThumbDownAlt, Search } from '@material-ui/icons'
import {
  postBuscadorService,
  postLinkActionService,
} from '@auteco/services/buscadorService'

const RespuestaContainer = ({ respuesta }) => {
  const text = respuesta.answer.answerText

  // Function to handle copying to the clipboard
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(
      () => alert('Copiado al portapales'),
      () => alert('Failed to copy text.'),
    )
  }

  const formatTextWithBoldAndList = (text) => {
    const boldRegex = /\*\*(.*?)\*\*/g // Buscar texto entre ** para negrita
    const listRegex = /\n\* (.*?)(?=\n|$)/g // Buscar elementos de lista con *

    // Reemplazar las listas por <li>
    const processedText = text
      .replace(listRegex, '<li>$1</li>')
      .replace(/\n\n/g, '</ul> <p></p> <ul>') // Convertir dobles saltos en <ul>
      .replace(/\n/g, '<br/>') // Saltos de línea normales
      .replace(boldRegex, '<strong>$1</strong>') // Reemplazar negrita
    return processedText
  }

  // Splitting paragraphs for copy functionality
  const paragraphs = text.split(/\n\n/) // Split paragraphs by double newlines

  return (
    <>
      {paragraphs.map((paragraph, index) => (
        <div key={index} style={{ position: 'relative', marginBottom: '20px' }}>
          <Typography variant="body1" paragraph>
            <div
              dangerouslySetInnerHTML={{
                __html: `<ul>${formatTextWithBoldAndList(paragraph)}</ul>`,
              }}
            />
          </Typography>
          <Button
            variant="contained"
            color="primary"
            style={{
              position: 'absolute',
              background: 'none',
              height: '0',
              bottom: '0',
              right: '0',
              padding: 'none',
            }}
            onClick={() => copyToClipboard(paragraph)}
          >
            📄
          </Button>
        </div>
      ))}
    </>
  )
}

const BusquedaContainer = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [respuestgenerada, setRespuestgenerada] = useState(null)
  const [loading, setLoading] = useState(false)

  const handlePostBuscador = async (query) => {
    setLoading(true)
    setRespuestgenerada(null)
    const response = await postBuscadorService({
      query,
      sessionId: '',
      pageSize: 10,
    })
    if (response) {
      setRespuestgenerada(response)
    } else {
      console.log('no hay respuesta')
    }
    setLoading(false)
  }

  const handleSearch = () => {
    if (searchTerm.trim() !== '') {
      handlePostBuscador(searchTerm)
    }
  }

  const handleClickLink = async (link) => {
    const response = await postLinkActionService({
      link,
      idRespuesta: respuestgenerada.id,
    })
    if (response) {
      console.log('se ha registrado el click')
    }
  }

  useEffect(() => {
    // handlePostBuscador();
  }, [])

  const renderReferenceButtons = () => {
    if (
      !respuestgenerada ||
      !respuestgenerada.answer ||
      !respuestgenerada.answer.citations
    ) {
      return null
    }

    const uniqueSources = new Set()
    respuestgenerada.answer.citations.forEach((citation) => {
      citation.sources.forEach((source) => {
        if (source.referenceId) {
          uniqueSources.add(source.referenceId)
        }
      })
    })

    return Array.from(uniqueSources).map((referenceId, index) => {
      const result = respuestgenerada.results.find((r) => r.id === referenceId)
      if (!result) return null

      return (
        <Button
          key={referenceId}
          variant="outlined"
          color="primary"
          href={result.document.derivedStructData.link}
          target="_blank"
          rel="noopener noreferrer"
          style={{ margin: '0 8px 8px 0' }}
        >
          {`[${index + 1}]`}
        </Button>
      )
    })
  }

  return (
    <Box sx={{ maxWidth: 800, margin: 'auto', mt: 4 }}>
      <Card elevation={3} style={{ padding: 25 }}>
        <CardContent>
          <Box mb={3}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Buscar mejores tvs para carretera"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSearch}
                      startIcon={<Search />}
                      disabled={loading}
                      style={{
                        width: '100px',
                      }}
                    >
                      Buscar
                    </Button>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          {loading && (
            <div
              style={{ width: '100%', height: '500px' }}
              className={`${loading ? 'my-loading' : ''}`}
            >
              {' '}
            </div>
          )}
          {true && respuestgenerada && (
            <>
              <Box
                style={{ marginBottom: '20px' }}
                mt={3}
                display="flex"
                justifyContent="flex-end"
              >
                <ThumbUpAlt
                  color="action"
                  style={{ marginRight: 8, cursor: 'pointer' }}
                />
                <ThumbDownAlt color="action" style={{ cursor: 'pointer' }} />
              </Box>
              <RespuestaContainer respuesta={respuestgenerada} />
              <Box mt={2}>
                {/* <Typography variant="h6" gutterBottom>
                  Referencias
                </Typography> */}
                {renderReferenceButtons()}
              </Box>

              {respuestgenerada.citations &&
                respuestgenerada.citations.length > 0 && (
                  <Box mt={2}>
                    <Typography variant="h6" gutterBottom>
                      Fuentes
                    </Typography>
                    {respuestgenerada.citations.map((citation, index) => (
                      <Typography key={index} variant="body2" paragraph>
                        {`[${index + 1}] ${citation.sources.join(', ')}`}
                      </Typography>
                    ))}
                  </Box>
                )}

              {respuestgenerada.results && respuestgenerada.results.length > 0 && (
                <Box mt={3}>
                  <Typography variant="h6" gutterBottom>
                    Resultados relacionados
                  </Typography>
                  <div
                    style={{
                      margin: '20px',
                    }}
                  >
                    {respuestgenerada.results.map((result, index) => (
                      <>
                        <Card key={index} variant="outlined" sx={{ mb: 2 }}>
                          <CardContent>
                            <Typography variant="subtitle1" gutterBottom>
                              <Link
                                href={result.document.derivedStructData.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() =>
                                  handleClickLink(
                                    result.document.derivedStructData.link,
                                  )
                                }
                              >
                                {result.document.derivedStructData.htmlTitle}
                              </Link>
                            </Typography>
                            <Typography
                              variant="body1"
                              dangerouslySetInnerHTML={{
                                __html:
                                  result.document.derivedStructData.snippets[0]
                                    .snippet,
                              }}
                            />
                            <Typography variant="body2" color="textSecondary">
                              {result.document.derivedStructData.displayLink}
                            </Typography>
                          </CardContent>
                        </Card>
                        <br />
                      </>
                    ))}
                  </div>
                </Box>
              )}
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  )
}

export default BusquedaContainer
